module.exports = __webpack_public_path__ + "static/media/world-can-can.9325f3f3.vtt";